module.exports = __webpack_public_path__ + "img/nbwxjc.972d3346.png";